export default "__VITE_ASSET__1ef305ad__"